import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class ProfileService {
  private http = inject(HttpClient);

  setAppSetting(payload: any): Observable<any> {
    return this.http.put<any>(`${environment.base_url}auth/setings/`, payload);
  }

  getAppSetting(): Observable<any> {
    return this.http
      .get<any>(`${environment.base_url}auth/setings/`)
      .pipe(map((res: any) => res.data));
  }
}
